import { render, staticRenderFns } from "./PageEditVehicle.vue?vue&type=template&id=25631442"
import script from "./PageEditVehicle.vue?vue&type=script&lang=js"
export * from "./PageEditVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports